var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.999,
    height: 21,
    viewBox: "0 0 26.999 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4621",
    "data-name": "Path 4621",
    d: "M-.394-13.481A3.691,3.691,0,0,1,0-13.5,4.474,4.474,0,0,1,4.5-9,4.5,4.5,0,0,1,0-4.5,4.474,4.474,0,0,1-4.5-9a3.69,3.69,0,0,1,.019-.394A3.441,3.441,0,0,0-3-9a3,3,0,0,0,3-3A3.441,3.441,0,0,0-.394-13.481Zm9.422-2.241a18.16,18.16,0,0,1,4.355,6.145,1.491,1.491,0,0,1,0,1.153A19.005,19.005,0,0,1,9.028-2.278,13.19,13.19,0,0,1,0,1.5,13.186,13.186,0,0,1-9.027-2.278a19.078,19.078,0,0,1-4.357-6.145,1.5,1.5,0,0,1,0-1.153,18.226,18.226,0,0,1,4.357-6.145A13.194,13.194,0,0,1,0-19.5,13.2,13.2,0,0,1,9.028-15.722ZM0-15.75A6.752,6.752,0,0,0-6.75-9,6.752,6.752,0,0,0,0-2.25,6.752,6.752,0,0,0,6.75-9,6.752,6.752,0,0,0,0-15.75Z",
    transform: "translate(13.5 19.5)",
    fill: "#a2a2a2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.ef17b6167ecbda8c3de67754fe40b8d7.svg";
export { ForwardRef as ReactComponent };